import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { modReportsDailyDownloads_template } from "../components/templates/modReportsDailyDownloads_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;

export class mod_reports_daily_downloads extends vnModule_knockoutJS {

    protected elementsList: modReportsDailyDownloads_template;

    protected getModuleName(): string {
        return "mod_reports_daily_downloads";
    }

    buildContent(): Array<Element> {
        this.elementsList = new modReportsDailyDownloads_template("dailyDownloads", this.viewModel, this);
        this.template = this.elementsList;

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        if (loadedModule) {
            (<header>loadedModule).setHeaderTitle("Daily downloads");
        }

        return [this.elementsList.build()];
    }

    public fillPage(): void {
        this.elementsList.initializeDatePickers();
        this.loadDailyDownloadsReport();
    }

    public loadDailyDownloadsReport(): void {
        const listEl = this.elementsList.builtTemplate.querySelector("#list-results");
        if (listEl) {
            this.loadingIn(listEl);
        }
        this.elementsList.getTemplateViewModel().loading(true);

        const payload = this.elementsList.getRequestPayload();
        const usrReq_url = "/api/mod/reports/daily-downloads/";
        const usrReq_params: Array<Array<string>> = [["data", ko.toJSON(payload)]];
        const key = "dailyDownloadsReport";
        if (this.XHRHdls[key]) {
            this.XHRHdls[key].cancelAndReset();
        }
        this.XHRHdls[key] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls[key].mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdls[key].onReadyStateFunction = this.onDailyDownloadsReturn;
        this.XHRHdls[key].execute();
    }

    protected onDailyDownloadsReturn(req: any, obj: mod_reports_daily_downloads) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            const listEl = obj.elementsList.builtTemplate.querySelector("#list-results");
            if (listEl) {
                obj.loadingOut(listEl);
            }
            obj.elementsList.getTemplateViewModel().loading(false);
            if (req.request.status === 200) {
                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response || "{}");
                    if (Array.isArray(responseParsed.data)) {
                        obj.elementsList.setRows(responseParsed.data);
                    }
                });
            } else {
                let msg = "Could not load report.";
                try {
                    const responseParsed = JSON.parse(req.request.response || "{}");
                    if (responseParsed.message) {
                        msg = responseParsed.message;
                    }
                } catch (e) {
                }
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_ERROR,
                    msg
                );
                obj.getVnAppZone().showNotificationToModule();
            }
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/mod_reports_daily_downloads.ts